import api from "./api";
import { normalizeApiEnvelope } from "@/utils/apiEnvelope";

export const warehousesService = {
  list() {
    return api.get("/warehouses");
  },
  get(id) {
    return api.get(`/warehouses/${id}`);
  },
  create(payload) {
    return api.post("/warehouses", payload);
  },
  update(id, payload) {
    return api.patch(`/warehouses/${id}`, payload);
  },
};

export const getWarehouses = async () => {
  const response = await warehousesService.list();
  return normalizeApiEnvelope(response);
};
